import contactApplicant from "./communication/contact-applicant";
import contactJobProfile from "./communication/contact-job-profile";
import conversation from "./communication/conversation";
import appointment from "./communication/appointment";

const store = {
	namespaced: true,
	modules: {
		contactApplicant,
		contactJobProfile,
		conversation,
		appointment,
	}
};

export default store;
